import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Homes/index'
import Homes from '../views/Homes/newa.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/homes',
    component: Homes
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
